<template>
  <div style="border:solid #2c2c2c; border-width:1px 0px;">
    <v-tabs
      :model-value="modelValue"
      @update:modelValue="onTabChange"
      color="white"
    >
      <v-tab v-for="tab in tabs" :key="tab.name" :value="tab.name" :disabled="tab.disabled" style="text-transform:none; letter-spacing:0;">
        <v-icon v-if="tab.icon" class="mr-2">{{tab.icon}}</v-icon>
        {{tab.label}}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  tabs: Array<{label?: string, name?: string, icon?: string, disabled?: boolean}>
  modelValue: string
}>();
const emit = defineEmits(['update:modelValue']);

function onTabChange(val: string) {
  emit('update:modelValue', val);
}
</script>
